import { useState } from 'react';
import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '漫画分类',
    links: [
      { label: '恋爱漫画', path: '/category/love' },
      { label: '奇幻漫画', path: '/category/fantasy' },
      { label: '动作漫画', path: '/category/action' },
      { label: '悬疑漫画', path: '/category/suspense' },
    ],
  },
  {
    title: '热门推荐',
    links: [
      { label: '魔王归来', path: '/comic/demon-king' },
      { label: '星光之恋', path: '/comic/star-romance' },
      { label: '秘密教学', path: '/comic/secret-class' },
      { label: '暗夜侦探', path: '/comic/dark-detective' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '用户口碑', path: '/about' },
      { label: '联系方式', path: '/about' },
      { label: '常见问题', path: '/about' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '阅读指南', path: '/about' },
      { label: '更新说明', path: '/about' },
      { label: '反馈建议', path: '/about' },
      { label: '服务条款', path: '/about' },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubscribeStatus('success');
    setEmail('');
    setTimeout(() => setSubscribeStatus('idle'), 3000);
  };

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:max-w-sm flex-shrink-0">
            <Link to="/" className="inline-block mb-6">
              <span className="font-heading text-3xl font-bold tracking-tight text-white">
                韩国漫画网
              </span>
            </Link>

            <form onSubmit={handleSubscribe} className="flex items-center gap-0 mb-6">
              <div className="flex items-center bg-background-800 rounded-full overflow-hidden">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱订阅更新"
                  className="bg-transparent text-background-100 placeholder:text-background-500 text-sm px-5 py-3 outline-none w-56"
                  aria-label="邮箱地址"
                  name="email"
                />
                <button
                  type="submit"
                  className="bg-accent-500 hover:bg-accent-600 text-white px-5 py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm font-medium"
                >
                  <i className="ri-notification-3-line text-base w-4 h-4 flex items-center justify-center" />
                </button>
              </div>
            </form>
            {subscribeStatus === 'success' && (
              <p className="text-accent-400 text-xs mb-4">订阅成功！感谢您的关注。</p>
            )}
            {subscribeStatus === 'error' && (
              <p className="text-red-400 text-xs mb-4">订阅失败，请重试。</p>
            )}

            <p className="font-heading text-xl text-background-200 leading-relaxed mb-2">
              好看的韩国漫画全集
            </p>
            <p className="font-heading text-xl text-background-200 leading-relaxed">
              韩漫在线观看 · 免费下拉式阅读
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 flex-1">
            {footerLinks.map((col) => (
              <div key={col.title}>
                <h4 className="text-background-100 font-semibold text-sm mb-4">
                  {col.title}
                </h4>
                <ul className="flex flex-col gap-3">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-background-400 hover:text-background-100 text-sm transition-colors whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; 2026 韩国漫画网. 韩漫在线观看 - 漫画免费下拉式阅读平台.
          </p>
          <div className="flex items-center gap-3">
            <a
              href="#"
              className="w-9 h-9 rounded-lg border border-background-600 flex items-center justify-center text-background-400 hover:text-background-100 hover:border-background-400 transition-colors cursor-pointer"
              aria-label="微信"
              rel="nofollow"
            >
              <i className="ri-wechat-line text-sm w-4 h-4 flex items-center justify-center" />
            </a>
            <a
              href="#"
              className="w-9 h-9 rounded-lg border border-background-600 flex items-center justify-center text-background-400 hover:text-background-100 hover:border-background-400 transition-colors cursor-pointer"
              aria-label="微博"
              rel="nofollow"
            >
              <i className="ri-weibo-line text-sm w-4 h-4 flex items-center justify-center" />
            </a>
            <a
              href="#"
              className="w-9 h-9 rounded-lg border border-background-600 flex items-center justify-center text-background-400 hover:text-background-100 hover:border-background-400 transition-colors cursor-pointer"
              aria-label="QQ"
              rel="nofollow"
            >
              <i className="ri-qq-line text-sm w-4 h-4 flex items-center justify-center" />
            </a>
            <a
              href="#"
              className="w-9 h-9 rounded-lg border border-background-600 flex items-center justify-center text-background-400 hover:text-background-100 hover:border-background-400 transition-colors cursor-pointer"
              aria-label="B站"
              rel="nofollow"
            >
              <i className="ri-bilibili-line text-sm w-4 h-4 flex items-center justify-center" />
            </a>
          </div>
          <Link to="/about" className="text-background-500 hover:text-background-300 text-xs transition-colors whitespace-nowrap">
            隐私政策
          </Link>
        </div>
      </div>
    </footer>
  );
}